/**
 * PUWYLO Card 1 (Keep Shopping For) NON-presentation SOT tracker (PDE-2806).
 *
 * Hands the tracker a `null` descriptor (renderable card or batch failure) → no-op.
 */

import { sendCmsComponentEvent } from 'analytics/utils/cmsComponents';
import constants from 'constants/content';

const { COMPONENT_TYPES } = constants;

/**
 * Fires exactly one PUWYLO Card 1 non-presentation SOT event through the shared
 * CMS-component dispatch, or nothing when handed a null descriptor.
 *
 * @param {{ sotType: string, sotFields: object }|null} event descriptor from the builder
 * @param {object} [meta]
 * @param {string} [meta.sid] the PUWYLO slot id
 * @param {string} [meta.title] recap title (or '')
 * @param {number} [meta.publishedVersion] CMS child published version for sotV316
 */
function firePuwyloBatchCard1SotEvent(event, { sid, title, publishedVersion } = {}) {
    if (!event) {
        return;
    }

    const item = { ...event.sotFields, sid };

    sendCmsComponentEvent({
        items: [item],
        eventName: event.sotType,
        title,
        sid,
        component: COMPONENT_TYPES.RECAP,
        publishedVersion
    });
}

export { firePuwyloBatchCard1SotEvent };
